import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";

const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

const dtrWithOtService = {
  upsert: async (payload) => {
    return await axios.post(`${domain}/api/DTRWithOtViewing/upsert`, payload, { headers });
  },

  approve: async (payload) => {
    // FIX: Change this label from "upsert:" to "approve:"
    return await axios.post(`${domain}/api/DTRWithOtViewing/approve`, payload, { headers });
  },
  // We'll add Approve here later
};

export default dtrWithOtService;